import React from 'react';
import Box from '@mui/material/Box';

export default function Loading() {
    return (
        <Box display="flex" mt={4} justifyContent="center">
            {/* <CircularProgress /> */}
            <h1>Loading...</h1>
        </Box>
    );
}
